import(/* webpackMode: "eager" */ "/vercel/path0/src/app/customer/page.js");
